import { KYMW1100Model } from '../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';



/**
 *商品栄養成分削除クラス
 *
 * @export DeleteNutrientCompositionService
 * @class DeleteNutrientCompositionService
 * @extends {PlessResponder}
 */
@Injectable()
export class DeleteNutrientCompositionService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteNutrientCompositionService
   */
  private getBody(): PlessRequest {
    // 生協コードの分を作成して追加
    const analysisSeqNoList = (<string>this.vo.analysisSeqNo).split(',').map(seqNo => ({
      condition: {
        AnalysisSeqNo: seqNo
      }
    }));

    return new PlessRequest({
      delete: {
        DeleteNutrient: {
          condition: {
            PCode: this.vo.pCode,
            ItemCode: this.vo.itemCode
          }
        },
        AnalysisSeqNoList: {
          combination: analysisSeqNoList
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteNutrientCompositionService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteNutrientComposition', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteNutrientCompositionService
   */
  success(data: any): void {
    this.model.updateGoodsNutrientInfo(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
